import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { AddIORModal } from './add-ior-modal';
import { DeleteIORModal } from './delete-ior-modal';
import messages from './messages';
import style from './style.module.less';
import Address from '../../../components/address';
import { useIOR } from '../../../hooks/use-ior';
import { useModal } from '../../../hooks/use-modal';

export const IORSection = () => {
  const { isOpen: isAddModalOpen, open: openAddModal, close: closeAddModal } = useModal();
  const { isOpen: isDeleteModalOpen, open: openDeleteModal, close: closeDeleteModal } = useModal();
  const [selectedIdToDelete, setSelectedIdToDelete] = useState(null);
  const { activeIORs, addSellerIOR, deleteSellerIOR } = useIOR();

  const onDelete = useCallback(
    async (iorId) => {
      await deleteSellerIOR(iorId);
      closeDeleteModal();
      setSelectedIdToDelete(null);
    },
    [closeDeleteModal, deleteSellerIOR],
  );

  const onAdd = useCallback(
    async (iorData) => {
      await addSellerIOR(iorData);
      closeAddModal();
    },
    [closeAddModal, addSellerIOR],
  );

  const handleClickOnDelete = (iorId) => {
    setSelectedIdToDelete(iorId);
    openDeleteModal();
  };

  return (
    <>
      {activeIORs.length > 0 ? (
        <>
          <div className={style['ior-grid']}>
            <div className={style['header-cell']}>
              <Text isBold textType={TextType.Paragraph} value={messages.iorNameField} />
            </div>
            <div className={style['header-cell']}>
              <Text isBold textType={TextType.Paragraph} value={messages.iorAddressField} />
            </div>
            <div className={style['header-cell']} />
            {activeIORs?.map((ior) => (
              <React.Fragment key={ior.id}>
                <div className={classNames([style.cell], style['first-cell'])}>
                  <Text textType={TextType.Paragraph} value={ior.name} />
                </div>
                <div className={style.cell}>
                  <Address address={ior} />
                </div>
                <div className={classNames([style.cell], style['last-cell'])}>
                  {ior.isActive ? (
                    <Button className={style['delete-row']} onClick={() => handleClickOnDelete(ior.id)} theme='link'>
                      <FormattedMessage {...messages.delete} />
                    </Button>
                  ) : null}
                </div>
              </React.Fragment>
            ))}
          </div>
          <Button className={style['add-another-table-button']} onClick={openAddModal} theme='link'>
            <FontAwesomeIcon className={style.icon} icon={faPlus} />
            <FormattedMessage {...messages.addIOR} />
          </Button>
        </>
      ) : (
        <>
          <div className={style.subtext}>
            <FormattedMessage {...messages.addIORSubtext} />
          </div>
          <div className={style['add-tax-id-wrapper']}>
            <Button className={style['add-tax-id-button']} onClick={openAddModal} theme='primary'>
              <FormattedMessage {...messages.addIOR} />
            </Button>
          </div>
        </>
      )}
      {isDeleteModalOpen ? <DeleteIORModal iorId={selectedIdToDelete} onClose={closeDeleteModal} onDelete={onDelete} /> : null}
      {isAddModalOpen ? <AddIORModal onAddIOR={onAdd} onClose={closeAddModal} /> : null}
    </>
  );
};
